// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AskRouteImport } from './routes/ask'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AvailabilityRouteImport } from './routes/availability'
import { Route as CommunityRouteImport } from './routes/community'
import { Route as ExteriorCustomerQuoteRouteImport } from './routes/exterior-customer-quote'
import { Route as FeedRouteImport } from './routes/feed'
import { Route as GetAQuoteRouteImport } from './routes/get-a-quote'
import { Route as GuidesRouteImport } from './routes/guides'
import { Route as HelpRouteImport } from './routes/help'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as PartnerLeadResponseRouteImport } from './routes/partner-lead-response'
import { Route as PartnerWithShieldsRouteImport } from './routes/partner-with-shields'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as QuoteRouteImport } from './routes/quote'
import { Route as QuoteConfirmationRouteImport } from './routes/quote-confirmation'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedBookRouteImport } from './routes/_authenticated/book'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedInboxRouteImport } from './routes/_authenticated/inbox'
import { Route as AuthenticatedMyPropertyRouteImport } from './routes/_authenticated/my-property'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedPersonaliseRouteImport } from './routes/_authenticated/personalise'
import { Route as AuthenticatedTeamInvitationsRouteImport } from './routes/_authenticated/team-invitations'
import { Route as GuidesSlugRouteImport } from './routes/guides_.$slug'
import { Route as PartnersPartnerIdRouteImport } from './routes/partners.$partnerId'
import { Route as UUsernameRouteImport } from './routes/u.$username'
import { Route as AuthenticatedBookingsIndexRouteImport } from './routes/_authenticated/bookings/index'
import { Route as AuthenticatedBookingsBookingIdRouteImport } from './routes/_authenticated/bookings/$bookingId'
import { Route as AuthenticatedCustomerIndexRouteImport } from './routes/_authenticated/customer/index'
import { Route as AuthenticatedCustomerAiRouteImport } from './routes/_authenticated/customer/ai'
import { Route as AuthenticatedCustomerMoreRouteImport } from './routes/_authenticated/customer/more'
import { Route as AuthenticatedHomeHomeIdRouteImport } from './routes/_authenticated/home.$homeId'
import { Route as AuthenticatedHomeCalendarRouteImport } from './routes/_authenticated/home.calendar'
import { Route as AuthenticatedHomeHealthRouteImport } from './routes/_authenticated/home.health'
import { Route as AuthenticatedHomeHistoryRouteImport } from './routes/_authenticated/home.history'
import { Route as AuthenticatedHomeHouseholdRouteImport } from './routes/_authenticated/home.household'
import { Route as AuthenticatedHomeMaintenanceRouteImport } from './routes/_authenticated/home.maintenance'
import { Route as AuthenticatedHomePartnersRouteImport } from './routes/_authenticated/home.partners'
import { Route as AuthenticatedHomeVaultRouteImport } from './routes/_authenticated/home.vault'
import { Route as AuthenticatedJobPostPostIdRouteImport } from './routes/_authenticated/job-post.$postId'
import { Route as AuthenticatedMessagesIndexRouteImport } from './routes/_authenticated/messages/index'
import { Route as AuthenticatedMessagesBookingIdRouteImport } from './routes/_authenticated/messages/$bookingId'
import { Route as AuthenticatedOwnerIndexRouteImport } from './routes/_authenticated/owner/index'
import { Route as AuthenticatedOwnerAchievementsRouteImport } from './routes/_authenticated/owner/achievements'
import { Route as AuthenticatedOwnerAgentsRouteImport } from './routes/_authenticated/owner/agents'
import { Route as AuthenticatedOwnerAiRouteImport } from './routes/_authenticated/owner/ai'
import { Route as AuthenticatedOwnerApprovalsRouteImport } from './routes/_authenticated/owner/approvals'
import { Route as AuthenticatedOwnerAutomationRouteImport } from './routes/_authenticated/owner/automation'
import { Route as AuthenticatedOwnerExteriorLeadsRouteImport } from './routes/_authenticated/owner/exterior-leads'
import { Route as AuthenticatedOwnerLeadsRouteImport } from './routes/_authenticated/owner/leads'
import { Route as AuthenticatedOwnerMembershipsRouteImport } from './routes/_authenticated/owner/memberships'
import { Route as AuthenticatedOwnerModerationRouteImport } from './routes/_authenticated/owner/moderation'
import { Route as AuthenticatedOwnerNotificationsRouteImport } from './routes/_authenticated/owner/notifications'
import { Route as AuthenticatedOwnerPaymentsRouteImport } from './routes/_authenticated/owner/payments'
import { Route as AuthenticatedOwnerSettingsRouteImport } from './routes/_authenticated/owner/settings'
import { Route as AuthenticatedPartnerIndexRouteImport } from './routes/_authenticated/partner/index'
import { Route as AuthenticatedPartnerApplyRouteImport } from './routes/_authenticated/partner/apply'
import { Route as AuthenticatedPartnerBusinessRouteRouteImport } from './routes/_authenticated/partner/business/route'
import { Route as AuthenticatedPartnerLeadsRouteImport } from './routes/_authenticated/partner/leads'
import { Route as AuthenticatedPartnerNotificationsRouteImport } from './routes/_authenticated/partner/notifications'
import { Route as AuthenticatedPartnerPaymentsRouteImport } from './routes/_authenticated/partner/payments'
import { Route as AuthenticatedPartnerProfileRouteImport } from './routes/_authenticated/partner/profile'
import { Route as AuthenticatedPartnerQuoteRequestsRouteImport } from './routes/_authenticated/partner/quote-requests'
import { Route as AuthenticatedPartnerServiceAreasRouteImport } from './routes/_authenticated/partner/service-areas'
import { Route as AuthenticatedPartnerSettingsRouteImport } from './routes/_authenticated/partner/settings'
import { Route as AuthenticatedPartnerVerificationRouteImport } from './routes/_authenticated/partner/verification'
import { Route as AuthenticatedPartnerWalletRouteImport } from './routes/_authenticated/partner/wallet'
import { Route as AuthenticatedBookingsBookingIdPaymentRouteImport } from './routes/_authenticated/bookings/$bookingId/payment'
import { Route as AuthenticatedOwnerApplicationsApplicationIdRouteImport } from './routes/_authenticated/owner/applications.$applicationId'
import { Route as AuthenticatedPartnerBusinessIndexRouteImport } from './routes/_authenticated/partner/business/index'
import { Route as AuthenticatedPartnerBusinessModuleRouteImport } from './routes/_authenticated/partner/business/$module'
import { Route as AuthenticatedPartnerBusinessCalendarRouteImport } from './routes/_authenticated/partner/business/calendar'
import { Route as AuthenticatedPartnerBusinessTeamRouteImport } from './routes/_authenticated/partner/business/team'
import { Route as AuthenticatedPartnerJobsIndexRouteImport } from './routes/_authenticated/partner/jobs/index'
import { Route as AuthenticatedPartnerJobsBookingIdRouteImport } from './routes/_authenticated/partner/jobs/$bookingId'
import { Route as AuthenticatedPartnerMessagesIndexRouteImport } from './routes/_authenticated/partner/messages/index'
import { Route as AuthenticatedPartnerMessagesBookingIdRouteImport } from './routes/_authenticated/partner/messages/$bookingId'
import { Route as AuthenticatedPartnerOffersIndexRouteImport } from './routes/_authenticated/partner/offers/index'
import { Route as AuthenticatedPartnerOffersOfferIdRouteImport } from './routes/_authenticated/partner/offers/$offerId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AskRoute = AskRouteImport.update({
            id: '/ask',path: '/ask',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AvailabilityRoute = AvailabilityRouteImport.update({
            id: '/availability',path: '/availability',getParentRoute: () => rootRouteImport
          })
const CommunityRoute = CommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => rootRouteImport
          })
const ExteriorCustomerQuoteRoute = ExteriorCustomerQuoteRouteImport.update({
            id: '/exterior-customer-quote',path: '/exterior-customer-quote',getParentRoute: () => rootRouteImport
          })
const FeedRoute = FeedRouteImport.update({
            id: '/feed',path: '/feed',getParentRoute: () => rootRouteImport
          })
const GetAQuoteRoute = GetAQuoteRouteImport.update({
            id: '/get-a-quote',path: '/get-a-quote',getParentRoute: () => rootRouteImport
          })
const GuidesRoute = GuidesRouteImport.update({
            id: '/guides',path: '/guides',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const LeaderboardRoute = LeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => rootRouteImport
          })
const PartnerLeadResponseRoute = PartnerLeadResponseRouteImport.update({
            id: '/partner-lead-response',path: '/partner-lead-response',getParentRoute: () => rootRouteImport
          })
const PartnerWithShieldsRoute = PartnerWithShieldsRouteImport.update({
            id: '/partner-with-shields',path: '/partner-with-shields',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const PlansRoute = PlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => rootRouteImport
          })
const QuoteRoute = QuoteRouteImport.update({
            id: '/quote',path: '/quote',getParentRoute: () => rootRouteImport
          })
const QuoteConfirmationRoute = QuoteConfirmationRouteImport.update({
            id: '/quote-confirmation',path: '/quote-confirmation',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBookRoute = AuthenticatedBookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedInboxRoute = AuthenticatedInboxRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMyPropertyRoute = AuthenticatedMyPropertyRouteImport.update({
            id: '/my-property',path: '/my-property',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedNotificationsRoute = AuthenticatedNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPersonaliseRoute = AuthenticatedPersonaliseRouteImport.update({
            id: '/personalise',path: '/personalise',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedTeamInvitationsRoute = AuthenticatedTeamInvitationsRouteImport.update({
            id: '/team-invitations',path: '/team-invitations',getParentRoute: () => AuthenticatedRouteRoute
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides_/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })
const PartnersPartnerIdRoute = PartnersPartnerIdRouteImport.update({
            id: '/$partnerId',path: '/$partnerId',getParentRoute: () => PartnersRoute
          })
const UUsernameRoute = UUsernameRouteImport.update({
            id: '/u/$username',path: '/u/$username',getParentRoute: () => rootRouteImport
          })
const AuthenticatedBookingsIndexRoute = AuthenticatedBookingsIndexRouteImport.update({
            id: '/bookings/',path: '/bookings/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBookingsBookingIdRoute = AuthenticatedBookingsBookingIdRouteImport.update({
            id: '/bookings/$bookingId',path: '/bookings/$bookingId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCustomerIndexRoute = AuthenticatedCustomerIndexRouteImport.update({
            id: '/customer/',path: '/customer/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCustomerAiRoute = AuthenticatedCustomerAiRouteImport.update({
            id: '/customer/ai',path: '/customer/ai',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCustomerMoreRoute = AuthenticatedCustomerMoreRouteImport.update({
            id: '/customer/more',path: '/customer/more',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHomeHomeIdRoute = AuthenticatedHomeHomeIdRouteImport.update({
            id: '/$homeId',path: '/$homeId',getParentRoute: () => AuthenticatedHomeRoute
          })
const AuthenticatedHomeCalendarRoute = AuthenticatedHomeCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthenticatedHomeRoute
          })
const AuthenticatedHomeHealthRoute = AuthenticatedHomeHealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => AuthenticatedHomeRoute
          })
const AuthenticatedHomeHistoryRoute = AuthenticatedHomeHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => AuthenticatedHomeRoute
          })
const AuthenticatedHomeHouseholdRoute = AuthenticatedHomeHouseholdRouteImport.update({
            id: '/household',path: '/household',getParentRoute: () => AuthenticatedHomeRoute
          })
const AuthenticatedHomeMaintenanceRoute = AuthenticatedHomeMaintenanceRouteImport.update({
            id: '/maintenance',path: '/maintenance',getParentRoute: () => AuthenticatedHomeRoute
          })
const AuthenticatedHomePartnersRoute = AuthenticatedHomePartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => AuthenticatedHomeRoute
          })
const AuthenticatedHomeVaultRoute = AuthenticatedHomeVaultRouteImport.update({
            id: '/vault',path: '/vault',getParentRoute: () => AuthenticatedHomeRoute
          })
const AuthenticatedJobPostPostIdRoute = AuthenticatedJobPostPostIdRouteImport.update({
            id: '/job-post/$postId',path: '/job-post/$postId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMessagesIndexRoute = AuthenticatedMessagesIndexRouteImport.update({
            id: '/messages/',path: '/messages/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMessagesBookingIdRoute = AuthenticatedMessagesBookingIdRouteImport.update({
            id: '/messages/$bookingId',path: '/messages/$bookingId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerIndexRoute = AuthenticatedOwnerIndexRouteImport.update({
            id: '/owner/',path: '/owner/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerAchievementsRoute = AuthenticatedOwnerAchievementsRouteImport.update({
            id: '/owner/achievements',path: '/owner/achievements',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerAgentsRoute = AuthenticatedOwnerAgentsRouteImport.update({
            id: '/owner/agents',path: '/owner/agents',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerAiRoute = AuthenticatedOwnerAiRouteImport.update({
            id: '/owner/ai',path: '/owner/ai',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerApprovalsRoute = AuthenticatedOwnerApprovalsRouteImport.update({
            id: '/owner/approvals',path: '/owner/approvals',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerAutomationRoute = AuthenticatedOwnerAutomationRouteImport.update({
            id: '/owner/automation',path: '/owner/automation',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerExteriorLeadsRoute = AuthenticatedOwnerExteriorLeadsRouteImport.update({
            id: '/owner/exterior-leads',path: '/owner/exterior-leads',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerLeadsRoute = AuthenticatedOwnerLeadsRouteImport.update({
            id: '/owner/leads',path: '/owner/leads',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerMembershipsRoute = AuthenticatedOwnerMembershipsRouteImport.update({
            id: '/owner/memberships',path: '/owner/memberships',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerModerationRoute = AuthenticatedOwnerModerationRouteImport.update({
            id: '/owner/moderation',path: '/owner/moderation',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerNotificationsRoute = AuthenticatedOwnerNotificationsRouteImport.update({
            id: '/owner/notifications',path: '/owner/notifications',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerPaymentsRoute = AuthenticatedOwnerPaymentsRouteImport.update({
            id: '/owner/payments',path: '/owner/payments',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOwnerSettingsRoute = AuthenticatedOwnerSettingsRouteImport.update({
            id: '/owner/settings',path: '/owner/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerIndexRoute = AuthenticatedPartnerIndexRouteImport.update({
            id: '/partner/',path: '/partner/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerApplyRoute = AuthenticatedPartnerApplyRouteImport.update({
            id: '/partner/apply',path: '/partner/apply',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerBusinessRouteRoute = AuthenticatedPartnerBusinessRouteRouteImport.update({
            id: '/partner/business',path: '/partner/business',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerLeadsRoute = AuthenticatedPartnerLeadsRouteImport.update({
            id: '/partner/leads',path: '/partner/leads',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerNotificationsRoute = AuthenticatedPartnerNotificationsRouteImport.update({
            id: '/partner/notifications',path: '/partner/notifications',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerPaymentsRoute = AuthenticatedPartnerPaymentsRouteImport.update({
            id: '/partner/payments',path: '/partner/payments',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerProfileRoute = AuthenticatedPartnerProfileRouteImport.update({
            id: '/partner/profile',path: '/partner/profile',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerQuoteRequestsRoute = AuthenticatedPartnerQuoteRequestsRouteImport.update({
            id: '/partner/quote-requests',path: '/partner/quote-requests',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerServiceAreasRoute = AuthenticatedPartnerServiceAreasRouteImport.update({
            id: '/partner/service-areas',path: '/partner/service-areas',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerSettingsRoute = AuthenticatedPartnerSettingsRouteImport.update({
            id: '/partner/settings',path: '/partner/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerVerificationRoute = AuthenticatedPartnerVerificationRouteImport.update({
            id: '/partner/verification',path: '/partner/verification',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerWalletRoute = AuthenticatedPartnerWalletRouteImport.update({
            id: '/partner/wallet',path: '/partner/wallet',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBookingsBookingIdPaymentRoute = AuthenticatedBookingsBookingIdPaymentRouteImport.update({
            id: '/payment',path: '/payment',getParentRoute: () => AuthenticatedBookingsBookingIdRoute
          })
const AuthenticatedOwnerApplicationsApplicationIdRoute = AuthenticatedOwnerApplicationsApplicationIdRouteImport.update({
            id: '/owner/applications/$applicationId',path: '/owner/applications/$applicationId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerBusinessIndexRoute = AuthenticatedPartnerBusinessIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedPartnerBusinessRouteRoute
          })
const AuthenticatedPartnerBusinessModuleRoute = AuthenticatedPartnerBusinessModuleRouteImport.update({
            id: '/$module',path: '/$module',getParentRoute: () => AuthenticatedPartnerBusinessRouteRoute
          })
const AuthenticatedPartnerBusinessCalendarRoute = AuthenticatedPartnerBusinessCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthenticatedPartnerBusinessRouteRoute
          })
const AuthenticatedPartnerBusinessTeamRoute = AuthenticatedPartnerBusinessTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AuthenticatedPartnerBusinessRouteRoute
          })
const AuthenticatedPartnerJobsIndexRoute = AuthenticatedPartnerJobsIndexRouteImport.update({
            id: '/partner/jobs/',path: '/partner/jobs/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerJobsBookingIdRoute = AuthenticatedPartnerJobsBookingIdRouteImport.update({
            id: '/partner/jobs/$bookingId',path: '/partner/jobs/$bookingId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerMessagesIndexRoute = AuthenticatedPartnerMessagesIndexRouteImport.update({
            id: '/partner/messages/',path: '/partner/messages/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerMessagesBookingIdRoute = AuthenticatedPartnerMessagesBookingIdRouteImport.update({
            id: '/partner/messages/$bookingId',path: '/partner/messages/$bookingId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerOffersIndexRoute = AuthenticatedPartnerOffersIndexRouteImport.update({
            id: '/partner/offers/',path: '/partner/offers/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerOffersOfferIdRoute = AuthenticatedPartnerOffersOfferIdRouteImport.update({
            id: '/partner/offers/$offerId',path: '/partner/offers/$offerId',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedHomeRouteChildren = {
  AuthenticatedHomeHomeIdRoute: AuthenticatedHomeHomeIdRoute,AuthenticatedHomeCalendarRoute: AuthenticatedHomeCalendarRoute,AuthenticatedHomeHealthRoute: AuthenticatedHomeHealthRoute,AuthenticatedHomeHistoryRoute: AuthenticatedHomeHistoryRoute,AuthenticatedHomeHouseholdRoute: AuthenticatedHomeHouseholdRoute,AuthenticatedHomeMaintenanceRoute: AuthenticatedHomeMaintenanceRoute,AuthenticatedHomePartnersRoute: AuthenticatedHomePartnersRoute,AuthenticatedHomeVaultRoute: AuthenticatedHomeVaultRoute
}

const AuthenticatedHomeRouteWithChildren = AuthenticatedHomeRoute._addFileChildren(AuthenticatedHomeRouteChildren)




const AuthenticatedPartnerBusinessRouteRouteChildren = {
  AuthenticatedPartnerBusinessModuleRoute: AuthenticatedPartnerBusinessModuleRoute,AuthenticatedPartnerBusinessCalendarRoute: AuthenticatedPartnerBusinessCalendarRoute,AuthenticatedPartnerBusinessTeamRoute: AuthenticatedPartnerBusinessTeamRoute,AuthenticatedPartnerBusinessIndexRoute: AuthenticatedPartnerBusinessIndexRoute
}

const AuthenticatedPartnerBusinessRouteRouteWithChildren = AuthenticatedPartnerBusinessRouteRoute._addFileChildren(AuthenticatedPartnerBusinessRouteRouteChildren)




const AuthenticatedBookingsBookingIdRouteChildren = {
  AuthenticatedBookingsBookingIdPaymentRoute: AuthenticatedBookingsBookingIdPaymentRoute
}

const AuthenticatedBookingsBookingIdRouteWithChildren = AuthenticatedBookingsBookingIdRoute._addFileChildren(AuthenticatedBookingsBookingIdRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,AuthenticatedBookRoute: AuthenticatedBookRoute,AuthenticatedHomeRoute: AuthenticatedHomeRouteWithChildren,AuthenticatedInboxRoute: AuthenticatedInboxRoute,AuthenticatedMyPropertyRoute: AuthenticatedMyPropertyRoute,AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,AuthenticatedPersonaliseRoute: AuthenticatedPersonaliseRoute,AuthenticatedTeamInvitationsRoute: AuthenticatedTeamInvitationsRoute,AuthenticatedPartnerBusinessRouteRoute: AuthenticatedPartnerBusinessRouteRouteWithChildren,AuthenticatedBookingsBookingIdRoute: AuthenticatedBookingsBookingIdRouteWithChildren,AuthenticatedCustomerAiRoute: AuthenticatedCustomerAiRoute,AuthenticatedCustomerMoreRoute: AuthenticatedCustomerMoreRoute,AuthenticatedJobPostPostIdRoute: AuthenticatedJobPostPostIdRoute,AuthenticatedMessagesBookingIdRoute: AuthenticatedMessagesBookingIdRoute,AuthenticatedOwnerAchievementsRoute: AuthenticatedOwnerAchievementsRoute,AuthenticatedOwnerAgentsRoute: AuthenticatedOwnerAgentsRoute,AuthenticatedOwnerAiRoute: AuthenticatedOwnerAiRoute,AuthenticatedOwnerApprovalsRoute: AuthenticatedOwnerApprovalsRoute,AuthenticatedOwnerAutomationRoute: AuthenticatedOwnerAutomationRoute,AuthenticatedOwnerExteriorLeadsRoute: AuthenticatedOwnerExteriorLeadsRoute,AuthenticatedOwnerLeadsRoute: AuthenticatedOwnerLeadsRoute,AuthenticatedOwnerMembershipsRoute: AuthenticatedOwnerMembershipsRoute,AuthenticatedOwnerModerationRoute: AuthenticatedOwnerModerationRoute,AuthenticatedOwnerNotificationsRoute: AuthenticatedOwnerNotificationsRoute,AuthenticatedOwnerPaymentsRoute: AuthenticatedOwnerPaymentsRoute,AuthenticatedOwnerSettingsRoute: AuthenticatedOwnerSettingsRoute,AuthenticatedPartnerApplyRoute: AuthenticatedPartnerApplyRoute,AuthenticatedPartnerLeadsRoute: AuthenticatedPartnerLeadsRoute,AuthenticatedPartnerNotificationsRoute: AuthenticatedPartnerNotificationsRoute,AuthenticatedPartnerPaymentsRoute: AuthenticatedPartnerPaymentsRoute,AuthenticatedPartnerProfileRoute: AuthenticatedPartnerProfileRoute,AuthenticatedPartnerQuoteRequestsRoute: AuthenticatedPartnerQuoteRequestsRoute,AuthenticatedPartnerServiceAreasRoute: AuthenticatedPartnerServiceAreasRoute,AuthenticatedPartnerSettingsRoute: AuthenticatedPartnerSettingsRoute,AuthenticatedPartnerVerificationRoute: AuthenticatedPartnerVerificationRoute,AuthenticatedPartnerWalletRoute: AuthenticatedPartnerWalletRoute,AuthenticatedBookingsIndexRoute: AuthenticatedBookingsIndexRoute,AuthenticatedCustomerIndexRoute: AuthenticatedCustomerIndexRoute,AuthenticatedMessagesIndexRoute: AuthenticatedMessagesIndexRoute,AuthenticatedOwnerIndexRoute: AuthenticatedOwnerIndexRoute,AuthenticatedPartnerIndexRoute: AuthenticatedPartnerIndexRoute,AuthenticatedOwnerApplicationsApplicationIdRoute: AuthenticatedOwnerApplicationsApplicationIdRoute,AuthenticatedPartnerJobsBookingIdRoute: AuthenticatedPartnerJobsBookingIdRoute,AuthenticatedPartnerMessagesBookingIdRoute: AuthenticatedPartnerMessagesBookingIdRoute,AuthenticatedPartnerOffersOfferIdRoute: AuthenticatedPartnerOffersOfferIdRoute,AuthenticatedPartnerJobsIndexRoute: AuthenticatedPartnerJobsIndexRoute,AuthenticatedPartnerMessagesIndexRoute: AuthenticatedPartnerMessagesIndexRoute,AuthenticatedPartnerOffersIndexRoute: AuthenticatedPartnerOffersIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const PartnersRouteChildren = {
  PartnersPartnerIdRoute: PartnersPartnerIdRoute
}

const PartnersRouteWithChildren = PartnersRoute._addFileChildren(PartnersRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AskRoute: AskRoute,AuthRoute: AuthRoute,AvailabilityRoute: AvailabilityRoute,CommunityRoute: CommunityRoute,ExteriorCustomerQuoteRoute: ExteriorCustomerQuoteRoute,FeedRoute: FeedRoute,GetAQuoteRoute: GetAQuoteRoute,GuidesRoute: GuidesRoute,HelpRoute: HelpRoute,HowItWorksRoute: HowItWorksRoute,LeaderboardRoute: LeaderboardRoute,PartnerLeadResponseRoute: PartnerLeadResponseRoute,PartnerWithShieldsRoute: PartnerWithShieldsRoute,PartnersRoute: PartnersRouteWithChildren,PlansRoute: PlansRoute,QuoteRoute: QuoteRoute,QuoteConfirmationRoute: QuoteConfirmationRoute,ResetPasswordRoute: ResetPasswordRoute,ServicesRoute: ServicesRoute,GuidesSlugRoute: GuidesSlugRoute,UUsernameRoute: UUsernameRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)